<template>
  <div class="box11">
    <pageTitle
      title="三师联合<br/>打造行业前沿的AI课程"
      text="课研老师+授课讲师+技术导师，保障课程前沿与教学落地"
      titleColor="#24375c"
      titColor="#86909C"
    />

    <div class="role-section">
      <div
        class="role-card"
        v-for="(item, index) in roleList"
        :key="index"
        :class="'role-card--' + (index + 1)"
      >
        <h3 class="role-card__title">{{ item.title }}</h3>
        <p class="role-card__text">
          <span>{{ item.desc }}</span>
          <span class="role-card__highlight">{{ item.highlight }}</span>
        </p>
      </div>
      <img
        class="role-section__plus role-section__plus--1"
        src="../../../assets/coursePage/llm/box11/icon-plus.png"
        alt=""
      />
      <img
        class="role-section__plus role-section__plus--2"
        src="../../../assets/coursePage/llm/box11/icon-plus.png"
        alt=""
      />
    </div>

    <div class="teacher-section">
      <swiper :options="swiperOption" ref="mySwiper" class="teacher-swiper">
        <swiper-slide
          class="teacher-slide"
          v-for="(slide, slideIndex) in teacherSlides"
          :key="slideIndex"
        >
          <div class="teacher-grid">
            <div
              class="teacher-card"
              v-for="(teacher, index) in slide"
              :key="index"
              @click="showTeacher(teacher)"
            >
              <img
                class="teacher-card__photo"
                :src="teacher.photo"
                alt=""
              />
              <div class="teacher-card__info">
                <p class="teacher-card__name">{{ teacher.name }}</p>
                <p class="teacher-card__role">{{ teacher.role }}</p>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-pagination-box11"></div>
    </div>

    <van-popup v-model="show" position="bottom" round>
      <div class="popup">
        <div class="popup__header">
          <div class="popup__title">{{ curTeacher.name }}</div>
          <div class="popup__close" @click="show = false"></div>
        </div>
        <div class="popup__tag">
          <span class="popup__tag-bg"></span>
          {{ curTeacher.role }}
        </div>
        <p class="popup__desc">{{ curTeacher.des }}</p>
        <p class="popup__intro">{{ curTeacher.intro }}</p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

/** 课研老师 */
const researchTeachers = [
  {
    name: "姚老师",
    role: "课研老师",
    des: "毕业于哈尔滨工程大学，资深技术专家，多年一线研发与课研经验",
    intro:
      "擅长 GIS 行业工程实战，在图像分割、检测、追踪等方面有多年从业经历，参与多项国家级/部委级重大项目，具备丰富的工程落地经验，课程研发侧重行业真实项目案例，强化技术应用能力，贴合岗位实操需求",
    photo: require("../../../assets/coursePage/llm/box11/1.png"),
  },
  {
    name: "李老师",
    role: "课研老师",
    des: "北京化工大学工学硕士，曾任多家互联网公司首席信息官，算法专家",
    intro:
      "拥有多年机器学习、深度学习算法研发经验，熟练 Python、Java 及 PyTorch、TensorFlow、PaddlePaddle 等框架，具备丰富 NLP 企业级实践经验，课程研发注重算法原理与工程实现结合，夯实学员技术底层能力",
    photo: require("../../../assets/coursePage/llm/box11/2.png"),
  },
  {
    name: "李老师",
    role: "课研老师",
    des: "韩国世翰大学情报学硕士，主攻自然语言处理与大模型方向",
    intro:
      "在人工智能领域拥有多年开发经验，擅长机器学习、深度学习、联邦学习，以及NLP与大语言模型等技术方向，在ToC及ToB场景均有落地及交付经验，专注于LLM课程研发与实战教学，致力于培养具备工程化能力的AI人才",
    photo: require("../../../assets/coursePage/llm/box11/3.png"),
  },
  {
    name: "李老师",
    role: "课研老师",
    des: "北京大学工学硕士，《深度学习理论与实战》畅销书作者",
    intro:
      "在多家头部互联网公司及知名外企工作过，拥有15年算法落地经验，深耕自然语言处理与多模态大模型领域，技术功底扎实，实战经验丰富，精通 LLM 预训练、微调、RLHF全流程及主流训练工具，课程研发紧贴前沿技术，注重高阶算法能力培养，匹配企业核心岗位需求",
    photo: require("../../../assets/coursePage/llm/box11/4.png"),
  },
  {
    name: "王老师",
    role: "课研老师",
    des: "17年架构经验，5年以上一线大厂高并发系统架构实战",
    intro:
      "曾任国家级央企数字化中台建设总设计师，传智教育 Java 架构学科带头人，国内 Java 与 AI 融合教育首批实践者，课程研发突出架构思维与技术融合，帮助学员构建大型复杂系统设计能力",
    photo: require("../../../assets/coursePage/llm/box11/5.png"),
  },
];

/** 高级讲师 */
const lecturerTeachers = [
  {
    name: "李老师",
    role: "高级讲师",
    des: "硕士学历，曾就职多家上市公司，任高级算法工程师、算法专家",
    intro:
      "多年 AI 算法研发与教学经验，研究覆盖 NLP、目标检测、视频跟踪、大模型、多模态、推理加速等，算法研发与工程落地经验丰富，授课逻辑清晰、视角前沿，擅长拆解技术原理，注重培养算法拆解与推理能力，助力学员建立落地思维",
    photo: require("../../../assets/coursePage/llm/box11/6.png"),
  },
  {
    name: "刘老师",
    role: "高级讲师",
    des: "多年 AI 开发与教学经验，课程覆盖 Python、机器学习、深度学习全阶段",
    intro:
      "精通 Python，熟练使用 PyTorch、Spark、TensorFlow 等框架，深耕 NLP、机器学习、深度学习领域，技术扎实、实战经验足，授课轻松活泼、深入浅出，善用案例拆解理论，课堂生动易懂，引导快速实操，强化动手与代码思维",
    photo: require("../../../assets/coursePage/llm/box11/7.png"),
  },
  {
    name: "邢老师",
    role: "高级讲师",
    des: "多年一线大厂经验，曾就职于字节、滴滴核心部门，大型项目实战经验丰富",
    intro:
      "专注大数据和人工智能领域，精通深度学习、NLP、大模型等技术，技术扎实、视野前沿，授课擅长对技术活学活用和解决复杂问题，融入大厂经验，培养架构思维，强化大型项目落地能力",
    photo: require("../../../assets/coursePage/llm/box11/8.png"),
  },
  {
    name: "魏老师",
    role: "高级讲师",
    des: "算法专家，曾在多家公司担任推荐算法工程师、机器学习算法工程师",
    intro:
      "多年人工智能开发经验，专注于大数据和人工智能领域技术，精通Python、Pytorch、Spark、PyTorch、TensorFlow、NLP等技术，授课内容涵盖Python编程、机器学习、深度学习、自然语言处理与大模型方向等，讲课以学生为本，通俗易懂",
    photo: require("../../../assets/coursePage/llm/box11/9.png"),
  },
  {
    name: "武老师",
    role: "高级讲师",
    des: "拥有13年软件开发与教学经验，曾担任企业高级技术架构师",
    intro:
      "精通 Java、Python 等编程语言，擅长数据挖掘、NLP自然语言处理和大模型应用开发领域，大型项目实战经验丰富；曾任上市集团分校校长，管理与教学经验非常丰富，授课风格独特，通俗易懂，激情满满，深受学员喜爱与高度好评，被学员们亲切地称为「六边形讲师」",
    photo: require("../../../assets/coursePage/llm/box11/10.png"),
  },
  {
    name: "杜老师",
    role: "高级讲师",
    des: "AI 架构师，有创业经历，曾任职京东、国美金融",
    intro:
      "多年 AI 与大数据算法实战经验，深度参与公安科技、智能营销、金融风控等核心业务系统的算法设计与落地，熟悉 Python、Java、C#，覆盖深度学习、NLP、推荐、大模型、RAG、多智能体，授课架构思维强、贴合业务，能灵活应用前沿技术解决复杂场景问题",
    photo: require("../../../assets/coursePage/llm/box11/11.png"),
  },
  {
    name: "李老师",
    role: "高级讲师",
    des: "前华为AI工程师，专注大数据与人工智能领域核心战场",
    intro:
      "精通Python、Java语言，擅长海量数据处理架构设计与模型优化，专注于机器学习与深度学习技术，熟练scikit-learn、PyTorch等框架，具备扎实的技术功底和丰富的实战经验，授课风格清晰生动，结合实战经验，帮助学员快速掌握行业前沿技术，深受学员喜爱",
    photo: require("../../../assets/coursePage/llm/box11/12.png"),
  },
];

/** 技术导师 */
const mentorTeachers = [
  {
    name: "孙老师",
    role: "技术导师",
    des: "工学学士，专注大模型应用开发与工程落地，实战经验丰富",
    intro:
      "拥有丰富智能 Agent 与大模型项目实战经验，深耕多智能体系统与 RAG 全流程研发落地，擅长大模型与真实业务深度融合，可独立交付标准化智能 Agent 方案，熟悉 MCP+A2A 分布式开发，掌握 LoRA、P‑Tuning 微调、vLLM 推理优化与部署调优，工程能力扎实、落地经验丰富",
    photo: require("../../../assets/coursePage/llm/box11/13.png"),
  },
  {
    name: "张老师",
    role: "技术导师",
    des: "工学硕士，专业基础扎实，精通大模型全栈技术",
    intro:
      "系统掌握机器学习、深度学习、NLP 与大模型核心理论，深耕大模型应用及工程落地，主攻自主 Agent 与 RAG 全流程研发，擅长 Agent 架构设计与 Harness 工程搭建，熟悉模型微调、推理引擎优化及多 Agent 开发，擅长技术结合业务落地，可独立输出标准化智能解决方案",
    photo: require("../../../assets/coursePage/llm/box11/14.png"),
  },
];

const allTeachers = [
  ...researchTeachers,
  ...lecturerTeachers,
  ...mentorTeachers,
];

/** 每屏展示 6 位老师 */
function chunkTeachers(list, size = 6) {
  const slides = [];
  for (let i = 0; i < list.length; i += size) {
    slides.push(list.slice(i, i + size));
  }
  return slides;
}

const teacherSlides = chunkTeachers(allTeachers, 6);

export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      show: false,
      curTeacher: {},
      swiperOption: {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination-box11",
        },
      },
      roleList: [
        {
          title: "课研老师",
          desc: "资深技术专家，对标岗位招聘标准，课程融入高频业务场景与核心技术栈，",
          highlight: "所学与企业需求零脱节",
        },
        {
          title: "授课讲师",
          desc: "10年+教龄，精通技术原理，擅长把抽象技术转换为通俗易懂的案例，",
          highlight: "零基础听得懂、练得会",
        },
        {
          title: "技术导师",
          desc: "一线企业出身，实战经验丰富。从入学到就业全程指导、答疑，",
          highlight: "让学员稳步实现就业转型",
        },
      ],
      teacherSlides,
    };
  },
  methods: {
    showTeacher(teacher) {
      this.curTeacher = teacher;
      this.show = true;
    },
  },
};
</script>

<style lang="less" scoped>
@import './variables.less';

.box11 {
  position: relative;
  padding: 80px 32px 80px;
  width: 100%;
  box-sizing: border-box;
  background: url("../../../assets/coursePage/llm/box11/bg.png") no-repeat top
    center;
  background-size: 100% 100%;
  background-color: #ffffff;
  overflow: hidden;

  /deep/ .course-title-box {
    position: relative;
    z-index: 1;
  }

  /deep/ .course-title {
    font-size: 48px;
    line-height: 68px;
    font-weight: 500;
  }

  /deep/ .course-text {
    font-size: 26px;
    line-height: 40px;
    margin-top: 14px;
  }

  .role-section {
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    margin-top: 48px;
    
  }

  .role-card {
    position: relative;
    flex: 1;
    max-width: 200px;
    min-height: 396px;
    padding: 16px 20px 24px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0 8px 28px 0 rgba(236, 236, 246, 1);
    text-align: center;
 background: url("../../../assets/coursePage/llm/box11/bg-item.png") no-repeat;
  background-size: 100% 100%;
    &--1 {
      z-index: 3;
      margin-right: -24px;
    }

    &--2 {
      z-index: 2;
      margin-right: -24px;
    }

    &--3 {
      z-index: 1;
    }

    &__title {
      margin: 0;
      font-family: PingFangSC, PingFang SC;
      font-size: 30px;
      font-weight: 700;
      color: #072557;
      line-height: 52px;
    }

    &__text {
      margin: 8px 0 0;
      font-family: PingFangSC, PingFang SC;
      font-size: 26px;
      font-weight: 400;
      color: #4b4e88;
      line-height: 38px;
      text-align: center;
    }

    &__highlight {
      font-weight: 600;
    }
  }

  .role-section__plus {
    position: absolute;
    top: 50%;
    width: 116px;
    height:auto;
    transform: translateY(-50%);
    object-fit: contain;
    pointer-events: none;
    z-index: 4;

    &--1 {
      left: calc(33.33% - 58px);
    }

    &--2 {
      left: calc(66.66% - 48px);
    }
  }

  .teacher-section {
    position: relative;
    z-index: 1;
    margin-top: 48px;
    padding-bottom: 36px;
  }

  .teacher-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px 13px;
  }

  .teacher-card {
    position: relative;
    width: 100%;
    height: 288px;
    overflow: hidden;
    background: linear-gradient(121deg, #f9f9ff 0%, #dcdcfe 70%, #dcdcfe 100%);
    border-radius: 40px;
    cursor: pointer;

    &__photo {
      display: block;
      width: 80%;
      height: 200px;
      object-fit: cover;
      margin:0 auto;
      position:relative;
      top:14px;
      object-position: top center;
    }

    &__info {
      position: absolute;
      left: 16px;
      right: 16px;
      bottom: 16px;
      padding: 12px 24px;
      background: linear-gradient( 180deg, #ECECFB 0%, #FFFFFF 100%);
border-radius: 24px;
    }

    &__name {
      margin: 0;
      font-family: PingFangSC, PingFang SC;
      font-size: 28px;
      font-weight: 500;
      color: #0f2654;
      line-height: 40px;
    }

    &__role {
      margin: 0;
      font-family: PingFangSC, PingFang SC;
      font-size: 24px;
      font-weight: 400;
      color: #6e7f94;
      line-height: 36px;
    }
  }

  .swiper-pagination-box11 {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
  }

  /deep/ .swiper-pagination-bullet {
    width: 12px;
    height: 6px;
    margin: 0 5px;
    border-radius: 3px;
    background: rgba(135, 93, 247, 0.16);
    opacity: 1;
  }

  /deep/ .swiper-pagination-bullet-active {
    width: 24px;
    background: #875df7;
  }

  .van-popup {
    max-height: calc(100vh - 80px);
    padding-bottom: 24px;
    box-sizing: border-box;
  }

  .popup {
    padding: 0 48px 24px;
    box-sizing: border-box;

    &__header {
      position: sticky;
      top: 0;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 132px;
      padding-top: 16px;
      background: #ffffff;
      box-sizing: border-box;
    }

    &__title {
      font-family: PingFangSC, PingFang SC;
      font-size: 36px;
      font-weight: 600;
      color: #1d2129;
      line-height: 48px;
    }

    &__close {
      width: 32px;
      height: 32px;
      background: url("../../../assets/coursePage/ai/box8/close.png") no-repeat
        center;
      background-size: cover;
      cursor: pointer;
    }

    &__tag {
      position: relative;
      display: inline-block;
      margin-bottom: 24px;
      padding: 0 24px;
      height: 56px;
      border-radius: 0 32px 32px 24px;
      font-family: PingFangSC, PingFang SC;
      font-size: 28px;
      font-weight: 500;
      .llm-text-gradient();
      line-height: 56px;

      &-bg {
        position: absolute;
        inset: 0;
        z-index: -1;
        border-radius: inherit;
        background: linear-gradient(129deg, #f0f0ff 0%, #dbe3ff 100%);
      }
    }

    &__desc {
      margin: 0 0 16px;
      font-family: PingFangSC, PingFang SC;
      font-size: 28px;
      font-weight: 500;
      color: #1d2129;
      line-height: 44px;
    }

    &__intro {
      margin: 0;
      font-family: PingFangSC, PingFang SC;
      font-size: 26px;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
    }
  }
}
</style>
